export default "__VITE_PUBLIC_ASSET__9fbb69bd__"